export class PromoRegraGrupo {
  public id: number;
  public promo_id: number;
  public promo_tipo: string;
  public entidade: string;
  public campo: string;
  public valor: string;
  public qtd: number;
  public tipo_preco: string;
  public percentual: number;
  public guidclientenapis: string;
  constructor() { }
}
